import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__style_text_bold",
  "use": "compose__style_text_bold-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"compose__style_text_bold\">\n  <title>Bold</title>\n  <text dominant-baseline=\"central\" font-weight=\"bold\" x=\"10.4\" y=\"10.4\" text-anchor=\"middle\">B</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol